const SettingsMeetings = () => <>hello world!</>;

export default SettingsMeetings;
